import React from 'react'

const LABELS: Record<string, string> = {
  search_projects: 'Projects',
  get_project: 'Projects',
  list_pipe_sets: 'Pipe sets',
  get_pipe_set: 'Pipe sets',
  get_wps_sections: 'Procedures',
  search_floorsheet_welds: 'Floor sheet',
  get_floorsheet_weld: 'Floor sheet',
  get_weld_parameters_summary: 'Weld parameters',
  search_generated_reports: 'Reports',
  get_generated_report: 'Reports',
  search_mech_welds: 'Mechanical tests',
  get_mech_weld: 'Mechanical tests',
  list_mech_reports: 'Mechanical tests',
  search_mech_results: 'Mechanical tests',
  search_team_members: 'Team',
  search_catalog: 'Catalog',
  project: 'Projects',
  pipe_set: 'Pipe sets'
}

export function sourceLabel(source: string) {
  return LABELS[source] || source.replace(/_/g, ' ')
}

export function SourceChips({ sources }: { sources?: string[] | null }) {
  if (!sources?.length) return null
  const unique = Array.from(new Set(sources.map(sourceLabel)))
  return (
    <div className="mt-3 flex flex-wrap items-center gap-1.5 border-t border-[#EEF0F3] pt-2.5">
      <span className="text-[10px] font-semibold uppercase tracking-wider text-heritage-grey">Sources:</span>
      {unique.map((label) => (
        <span
          key={label}
          className="rounded-full border border-[#E2E5EA] bg-page-bg px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.02em] text-blueprint-blue"
        >
          {label}
        </span>
      ))}
    </div>
  )
}
